import React from 'react';
import FileCard from './FileCard';

/**
 * FilesGridView Component
 * Responsive grid for displaying file cards
 */
export default function FilesGridView({
    files = [],
    selectedFile,
    onSelectFile,
    onPreviewFile,
    onDownloadFile,
    onPublishToCRE,
}) {
    if (!files.length) {
        return (
            <div className="py-16 text-center bg-white dark:bg-[#141c2b] rounded-xl border border-dashed border-[#c1c6d7] dark:border-[#344258]">
                <span className="material-symbols-outlined text-5xl text-[#727786] dark:text-[#5c687e] mb-3 block">
                    folder_open
                </span>
                <p className="text-base font-semibold text-[#0b1c30] dark:text-[#eaf1ff]">
                    No files in this folder
                </p>
                <p className="text-sm text-[#727786] dark:text-[#9aa5bc] mt-1">
                    Upload or drag files here to begin working.
                </p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {files.map((file) => (
                <FileCard
                    key={file.id}
                    file={file}
                    isSelected={selectedFile?.id === file.id}
                    onClick={onSelectFile}
                    onPreview={onPreviewFile}
                    onDownload={onDownloadFile}
                    onPublishToCRE={onPublishToCRE}
                />
            ))}
        </div>
    );
}
